export default __webpack_public_path__ + "5b2dee3a6548e372446a5eab595d07e0.jpg";